import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordSportModel} from '../../../api/model/medicalRecordSport.model';
import {MedicalRecordSportConverter} from '../../../api/converter/medicalRecordSport.converter';

@Injectable({providedIn: 'root'})
export class MedicalSportDataService
    extends AbstractDataServiceV2<MedicalRecordSportModel, MedicalRecordSportConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordSportConverter) {
        super('MedicalSport', http, httpUrlGenerator, logger, config, converter);
    }
}
